var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { create } from 'zustand';
import { GetReturnsEligibilityDetails } from '../hooks/returns-hooks';
import { RETURN_METHOD } from '../constants/general';
export var useReturnStore = create()(function () { return ({
    orderDetailsV2: undefined,
    orderId: undefined,
    isMilitaryExchangeGuest: false,
    tenders: [],
    returnEligibilityDetails: undefined,
    returnEligibilityLoading: false,
    policyValidatorResponse: undefined,
    alertState: null,
    selectedReturnItems: [],
    returnMethod: RETURN_METHOD.IN_STORE,
    orderBarcode: '',
    receiptNumber: '',
    militaryExchange: '',
    lorpContactDetails: undefined,
    isMultiAddressReturn: false,
    vendorReturnAddresses: undefined,
    returnBoxes: 1,
    multipleReturnBoxes: [],
    shipmentGroupedLineItems: undefined,
    orderDetailsPath: '/myaccount/order-details',
}); });
export var setReturnSession = function (_a) {
    var orderDetailsV2 = _a.orderDetailsV2, tenders = _a.tenders, orderId = _a.orderId, isMilitaryExchangeGuest = _a.isMilitaryExchangeGuest, militaryExchange = _a.militaryExchange, orderBarcode = _a.orderBarcode, receiptNumber = _a.receiptNumber, _b = _a.orderDetailsPath, orderDetailsPath = _b === void 0 ? '/myaccount/order-details' : _b;
    return useReturnStore.setState({
        orderDetailsV2: orderDetailsV2,
        tenders: tenders,
        orderId: orderId,
        isMilitaryExchangeGuest: isMilitaryExchangeGuest,
        militaryExchange: militaryExchange,
        orderBarcode: orderBarcode,
        receiptNumber: receiptNumber,
        orderDetailsPath: orderDetailsPath,
    });
};
export var setReturnMethod = function (value) {
    return useReturnStore.setState({ returnMethod: value });
};
export var setReturnEligibilityLoading = function (value) {
    return useReturnStore.setState({ returnEligibilityLoading: value });
};
// TODO we can remove returnBoxes once multipleReturnBoxes is fully implemented
export var setReturnBoxes = function (value) {
    return useReturnStore.setState({ returnBoxes: value });
};
export var setMultipleReturnBoxes = function (value) {
    return useReturnStore.setState({ multipleReturnBoxes: value });
};
export var setReturnEligibilityDetails = function (value) { return useReturnStore.setState({ returnEligibilityDetails: value }); };
export var setAlertState = function (value) {
    return useReturnStore.setState({ alertState: value });
};
export var setSelectedReturnItems = function (value) {
    return useReturnStore.setState({ selectedReturnItems: value });
};
export var setIsMultiAddressReturn = function (value) {
    return useReturnStore.setState({ isMultiAddressReturn: value });
};
export var setVendorReturnAddresses = function (value) {
    return useReturnStore.setState({ vendorReturnAddresses: value });
};
export var setShipmentGroupedLineItems = function (value) {
    return useReturnStore.setState({ shipmentGroupedLineItems: value });
};
export var getReturnEligibilityDetails = function (requestData) {
    setReturnEligibilityLoading(true);
    return GetReturnsEligibilityDetails(requestData, setReturnEligibilityDetails, setAlertState).finally(function () { return setReturnEligibilityLoading(false); });
};
export var setPolicyValidatorResponse = function (response) { return useReturnStore.setState({ policyValidatorResponse: response }); };
export var setLorpContactDetails = function (value) {
    return useReturnStore.setState({ lorpContactDetails: value });
};
export var _mockReturnStore = function (mockedState) {
    return useReturnStore.setState(function (state) { return (__assign(__assign({}, state), mockedState)); });
};
